// run the script from package.json to generate analytics events
import { AnalyticsEventsFactory as AnalyticsEventsFactoryZeus } from './apps/zeus/generated/analytics-events';
import { AnalyticsEventsFactory as AnalyticsEventsFactoryHermes } from './apps/hermes/generated/analytics-events';
import { AnalyticsEventsFactory as AnalyticsEventsFactoryMsTeams } from './apps/msTeams/generated/analytics-events';
import { AnalyticsEventsFactory as AnalyticsEventsFactoryUSL } from './apps/usl/generated/analytics-events';
import AnalyticsEngine from './common/analytics-engine';
import type { Options } from './common/analytics-engine';
import {
  removeForbiddenParameters,
  injectGoogleTagManager,
} from './common/helpers';

type OptionsWithoutAppName = Omit<Options, 'appName'>;

export class Analytics {
  public static AnalyticsEventsFactoryHermes(options: OptionsWithoutAppName) {
    return AnalyticsEventsFactoryHermes({ ...options, appName: 'Hermes' });
  }

  public static AnalyticsEventsFactoryMsTeams(options: OptionsWithoutAppName) {
    // this is an old name but we need to use it in GA tracking for continuity
    // elsewhere the name is msTeams, e.g. in the spreadsheet
    return AnalyticsEventsFactoryMsTeams({
      ...options,
      appName: 'LifeWorks Teams',
    });
  }

  public static AnalyticsEventsFactoryUSL(options: OptionsWithoutAppName) {
    return AnalyticsEventsFactoryUSL({ ...options, appName: 'USL' });
  }

  public static AnalyticsEventsFactoryZeus(options: OptionsWithoutAppName) {
    return AnalyticsEventsFactoryZeus({
      ...options,
      appName: 'Zeus',
    });
  }

  public static readonly AnalyticsEngine = AnalyticsEngine;

  public static readonly injectGoogleTagManager = injectGoogleTagManager;

  public static readonly removeForbiddenParameters = removeForbiddenParameters;
}
